import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, Button } from '@ncoder/ui';
import { BarChart3, Upload, Play } from 'lucide-react';

interface QuickActionsPanelProps {
  onViewAnalytics?: () => void;
  onImportDataset?: () => void;
  onStartTraining?: () => void;
}

export const QuickActionsPanel: React.FC<QuickActionsPanelProps> = ({
  onViewAnalytics,
  onImportDataset,
  onStartTraining,
}) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Quick Actions</CardTitle>
      </CardHeader>
      <CardContent className="space-y-2">
        <Button 
          variant="outline" 
          className="w-full justify-start"
          onClick={onViewAnalytics}
        >
          <BarChart3 className="h-4 w-4 mr-2" />
          View Analytics
        </Button>
        <Button 
          variant="outline" 
          className="w-full justify-start"
          onClick={onImportDataset}
        >
          <Upload className="h-4 w-4 mr-2" />
          Import Dataset
        </Button>
        <Button 
          variant="outline" 
          className="w-full justify-start"
          onClick={onStartTraining}
        >
          <Play className="h-4 w-4 mr-2" />
          Start Training
        </Button>
      </CardContent>
    </Card>
  );
};
